/* jshint esversion: 6 */
/* jshint ignore:start */
import { toast } from "react-toastify";
export const showTost = (title: string, type: 'success' | 'error' | 'info' = 'info') => {
    switch (type) {
        case 'success':
            toast.success(
                <div>
                    <strong>{title}</strong>
                </div>,
                { autoClose: 3000 }
            );
            break;
        case 'error':
            toast.error(
                <div>
                    <strong>{title}</strong>
                </div>,
                { autoClose: 3000 }
            );
            break;
        case 'info':
        default:
            toast.info(
                <div>
                    <strong>{title}</strong>
                </div>,
                { autoClose: 3000 }
            );
            break;
    }
};
/* jshint ignore:end */